import { render, staticRenderFns } from "./employeeCard.vue?vue&type=template&id=bd06c01c&scoped=true"
import script from "./employeeCard.vue?vue&type=script&lang=js"
export * from "./employeeCard.vue?vue&type=script&lang=js"
import style0 from "./employeeCard.vue?vue&type=style&index=0&id=bd06c01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd06c01c",
  null
  
)

export default component.exports